import PropTypes from 'prop-types';

export const LazyTransformWrapper = async () => {
  const TransformWrapper = import('react-zoom-pan-pinch').then((module) => ({
    default: module.TransformWrapper
  }));

  return TransformWrapper;
};

export const LazyTransformComponent = async () => {
  const TransformComponent = import('react-zoom-pan-pinch').then((module) => ({
    default: module.TransformComponent
  }));

  return TransformComponent;
};

export const TransformComponentDefault = ({ children }) => children;

TransformComponentDefault.propTypes = {
  children: PropTypes.node.isRequired,
  wrapperClass: PropTypes.string.isRequired,
  contentClass: PropTypes.string.isRequired
};

export const TransformWrapperDefault = ({ children }) => children;
